import React from "react";
import PropTypes from "prop-types";

// @components
import { ModalCustom } from 'commonsComponents/modalCustom';
import { HTMLSafeInjector } from 'commonsComponents/htmlSafeInjector';
import { OKButton } from 'commonsComponents/OKButton';

// @utilities
import { getUrlImages } from 'utilities/formatNgosList';

// @styles
import './okNgoModal.scss';

const OkNgoModal = ({
    isOpen,
    ngoDetail,
    ngoName,
    ngoLogo,
    onHandleClose,
    environmentConfig,
    ngo,
    ngoSelected,
    maxSelected,
    FormattedText,
    deleteLastOneOption
}) => {

    const buildModalHeader = () => {
        return(
            <div className="ok-ngomodal__header-bg" >
                <span className="ok-ngomodal__header-bg__title">{ngoName}</span>
                <img className="ok-ngomodal__header-bg__img" src={getUrlImages(ngoLogo, environmentConfig)}/>
            </div>
        )
    }

    const buildButtonModal = () => {
        const btnText = ngoSelected ? 'ngoModal-deseleccionar' : 'ngoModal-seleccionar';

        return (
            <div className="ok-ngomodal__footer">
                <OKButton onClick={() => onHandleClose(ngo)} >
                    <FormattedText value={btnText} />
                </OKButton>
            </div>
        )
    }

    const buildModalFooter = () => {
        if (deleteLastOneOption) return buildButtonModal();

        return(
            (maxSelected && !ngoSelected)?
                <div></div>
                :buildButtonModal()
        )
    }

    let infoStyle = (maxSelected && !ngoSelected) ? 'calc(100% - 250px)' : '';
    infoStyle = deleteLastOneOption ? 'calc(100% - 350px)' : infoStyle;

    return (
        <ModalCustom
            isOpen={isOpen}
            onRequestClose={() => onHandleClose(null)}
            overlayClassName="ok-ngomodal"
        >
            {buildModalHeader(ngoName, ngoLogo)}
            <div className="ok-ngomodal__main" style={{height: infoStyle}}>
                <div className="row">
                    <HTMLSafeInjector
                        message={ngoDetail}
                    />
                </div>
            </div>
            {buildModalFooter()}
        </ModalCustom>
    );
};

OkNgoModal.propTypes = {
    isOpen: PropTypes.bool,
    ngoDetail: PropTypes.string,
    ngoName: PropTypes.string,
    ngoLogo: PropTypes.string,
    onHandleClose: PropTypes.func,
    environmentConfig: PropTypes.string,
    ngoSelected: PropTypes.bool,
    maxSelected: PropTypes.bool,
    ngo: PropTypes.arrayOf(Object),
    FormattedText: PropTypes.func,
    deleteLastOneOption: PropTypes.bool
};

OkNgoModal.defaultProps = {
    isOpen: false,
    onHandleClose: () => null,
};

export default OkNgoModal;
